import { render, staticRenderFns } from "./PriorAuthorizationDetails.vue?vue&type=template&id=2c5ca312&scoped=true"
import script from "./PriorAuthorizationDetails.vue?vue&type=script&lang=ts"
export * from "./PriorAuthorizationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ca312",
  null
  
)

export default component.exports